export default __webpack_public_path__ + "static/media/dragoneye.07725ae3.PNG";